import { RouteObject } from "react-router-dom";
import { AddBidPackagePage } from "src/routes/bids/add-bid-package/AddBidPackagePage";
import { BidPackageDetailPage } from "src/routes/bids/BidPackageDetailPage";
import { BidPackagesPage } from "src/routes/bids/BidPackagesPage";
import { EnterPlanBasedBidPage } from "src/routes/bids/plan-based-bid-package/EnterPlanBasedBidPage";
import { PlanBasedBidPackagePage } from "src/routes/bids/plan-based-bid-package/PlanBasedBidPackagePage";
import { NotFound } from "src/routes/NotFound";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as bidPackagesPaths from "src/routing/domains/bidPackagesPaths";

/**
 * `/trades/bid-packages/*` route tree.
 *
 * Role: data router domain route.
 *
 * Legacy stack (pages still use `PageHeader` / stepper chrome, not Beam page layouts):
 * `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 *
 * Path constants live in `bidPackagesPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 * Legacy `Routes.tsx` / `TradesLayout` must not register these paths.
 */
const bidPackagesDomainRoute: RouteObject = {
  path: bidPackagesPaths.bidPackagesRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: BidPackagesPage },
            { path: bidPackagesPaths.bidPackageCreateRoute.path, Component: AddBidPackagePage },
            { path: bidPackagesPaths.bidPackageEditRoute.path, Component: AddBidPackagePage },
            { path: bidPackagesPaths.bidPackageDetailsRoute.path, Component: BidPackageDetailPage },
            { path: bidPackagesPaths.planBasedBidPackageCreateRoute.path, Component: PlanBasedBidPackagePage },
            { path: bidPackagesPaths.planBasedBidPackageEditRoute.path, Component: PlanBasedBidPackagePage },
            { path: bidPackagesPaths.enterPlanBasedBidRoute.path, Component: EnterPlanBasedBidPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/trades/bid-packages/*` route trees registered in `Router.tsx`.
 */
export const bidPackagesRoutes = [bidPackagesDomainRoute];
